import React from 'react';

type FolderbleButtonProps = {
  onClick: () => void;
};
export const FolderbleButton: React.FC<FolderbleButtonProps> = (props) => {
  return (
    <div className="btnCollapseWrap">
      <button className="btnCollapse" onClick={props.onClick}>
        {props.children}
      </button>
    </div>
  );
};
